(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wcslight", [], factory);
	else if(typeof exports === 'object')
		exports["wcslight"] = factory();
	else
		root["wcslight"] = factory();
})(self, () => {
return 